module.exports = __webpack_public_path__ + "img/segundo.a3945d96.png";